import { BorderRadius, Color } from '@billy/design-system'
import styled from '@emotion/styled'

interface IconBackgroundWrapperProps {
  backgroundColor: Color
}

export const IconBackgroundWrapper = styled.div<IconBackgroundWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: ${BorderRadius.RFull};
  background-color: ${({ backgroundColor }) => backgroundColor};
`
